import { RequestInfoFormTypes } from "./types";

export const emptyRequestInfoFormValues: RequestInfoFormTypes = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  company: "",
  materials: [],
  country: "",
  zipCode: "",
  state: "",
  subject: "",
  message: "",
  consents: {},
  stateId: "",
  city: "",
  machineSerialNumber: "",
  processOfInterest: [],
};
